import DriverLicenseAndPassport from 'src/assets/images/driver_license_and_passport.svg';
import { Color } from 'src/styles';

import { MTypography } from '../MTypography/MTypography';

export const IdentityVerificationInstructions = () => {
  return (
    <>
      <img src={DriverLicenseAndPassport} alt='Driver License and Passport' style={{ width: '100%' }} />
      <MTypography variant='subtitle1' color={Color.Gray7}>
        Please enter your name as shown on a government-issued ID (preferably your driver&apos;s license, state ID or
        passport).
      </MTypography>
    </>
  );
};
